import React from 'react';
import { CheckCircleIcon, CircleIcon } from 'lucide-react';
export const NextSteps = () => {
  const steps = [{
    id: 1,
    name: 'Submit your application',
    description: 'Complete your application for new accounts',
    status: 'completed'
  }, {
    id: 2,
    name: 'Application approved',
    description: 'Application review by financial institution',
    status: 'current'
  }, {
    id: 3,
    name: 'Sign account agreements',
    description: 'Review and sign all required documents',
    status: 'upcoming'
  }, {
    id: 4,
    name: 'Set up online banking',
    description: 'Create your online banking credentials',
    status: 'upcoming'
  }];
  return <div className="relative" data-id="element-328">
      {steps.map((step, index) => <div key={step.id} className="relative pb-8" data-id="element-329">
          {index !== steps.length - 1 && <div className="absolute left-3.5 top-6 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-330" />}
          <div className="relative flex items-start" data-id="element-331">
            <div className="flex h-7 items-center" data-id="element-332">
              {step.status === 'completed' ? <CheckCircleIcon className="h-7 w-7 text-[#5c5cf5]" data-id="element-333" /> : step.status === 'current' ? <div className="h-7 w-7 rounded-full border-2 border-[#5c5cf5] bg-white flex items-center justify-center" data-id="element-334">
                  <div className="h-3 w-3 rounded-full bg-[#5c5cf5]" data-id="element-335" />
                </div> : <CircleIcon className="h-7 w-7 text-gray-300" data-id="element-336" />}
            </div>
            <div className="ml-4 min-w-0 flex-1" data-id="element-337">
              <div data-id="element-338">
                <p className={`text-sm font-medium ${step.status === 'upcoming' ? 'text-gray-500' : 'text-gray-900'}`} data-id="element-339">
                  {step.name}
                </p>
                <p className="mt-1 text-xs text-gray-500" data-id="element-340">{step.description}</p>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
};